<div class="toolbar-container desktop-container">
  <img class="logo" src="/assets/images/logo_beta.svg" alt="logo" routerLink="">

  <div *ngIf="authService.$account.value" class="navigation-buttons">
    <button routerLink="control-panel" routerLinkActive="active-link">
      {{ 'toolbar.navControlPanel' | translate }}
    </button>

    <button routerLink="settings" routerLinkActive="active-link">
      {{ 'toolbar.navSettings' | translate }}
    </button>

    <button routerLink="payments" routerLinkActive="active-link">
      {{ 'toolbar.navPayments' | translate }}
    </button>
  </div>

  <div class="basic-actions">
    <span *ngIf="hasBeta()" class="exit-beta" (click)="exitBeta()">{{'toolbar.exitBeta' | translate}}</span>
    <button class="basic-actions__language-switcher" mat-button [matMenuTriggerFor]="menu">{{selectedLocale}}</button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let locale of localeEnum | keyvalue" (click)="changeLanguage(locale)">{{locale.key}}</button>
    </mat-menu>

    <button
      *ngIf="!authService.$account.value"
      class="basic-actions__login"
      color="primary"
      mat-flat-button
      (click)="openAuthModal()"
    >
      <img src="/assets/icons/login-button.svg" alt="login"/>
      {{ 'toolbar.loginButton' | translate }}
    </button>

    <button class="nav-balance" *ngIf="authService.$account.value?.login">
      {{ 'toolbar.navBalance' | translate }} <span>{{wallets[0]?.balance}}₽</span>
    </button>

    <button
      *ngIf="authService.$account.value"
      class="profile-button"
      color="primary"
      mat-flat-button
      [matMenuTriggerFor]="mobileMenu"
      (onMenuOpen)="toggleMobileMenuIcon()"
      (onMenuClose)="toggleMobileMenuIcon()"
    >
      <mat-icon svgIcon="profile-icon"></mat-icon>
    </button>

  </div>

  <div class="mobile-toolbar">
      <img src="/assets/images/mobile-logo_beta.svg" alt="mobile-logo">
      <button class="basic-actions__language-switcher" mat-button [matMenuTriggerFor]="menu">{{selectedLocale}}</button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngFor="let locale of localeEnum | keyvalue" (click)="changeLanguage(locale)">{{locale.key}}</button>
      </mat-menu>

    <button class="burger-menu" [matMenuTriggerFor]="mobileMenu"  mat-icon-button (onMenuOpen)="toggleMobileMenuIcon()" (onMenuClose)="toggleMobileMenuIcon()"><mat-icon [svgIcon]="mobileMenuIcon"></mat-icon></button>
    <mat-menu #mobileMenu="matMenu" class="burger-mat-menu" backdropClass="mobile-navigations-menu-backdrop">

        <p class="login-name">
          {{account?.login}}
        </p>

        <p class="balance">
          {{ 'toolbar.burgerBalance' | translate }} <span>{{wallets[0]?.balance}}₽</span>
        </p>

        <button *ngIf="!authService.$account.value" mat-menu-item routerLink="control-panel" (click)="openAuthModal()">
          {{ 'toolbar.loginButton' | translate }}
        </button>

        <button mat-menu-item routerLink="control-panel" routerLinkActive="active-link">
          {{ 'toolbar.navControlPanel' | translate }}
        </button>

        <button mat-menu-item routerLink="settings" routerLinkActive="active-link">
          {{ 'toolbar.navSettings' | translate }}
        </button>

        <button mat-menu-item routerLink="payments" routerLinkActive="active-link">
          {{ 'toolbar.navPayments' | translate }}
        </button>

        <button mat-menu-item (click)="goToLink('https://vk.me/donateall')">
          {{ 'toolbar.support' | translate }}
        </button>

        <button mat-menu-item class="logout" (click)="logout()">
          {{ 'toolbar.logout' | translate }}
        </button>
    </mat-menu>
  </div>

</div>

<img class="message-icon" *ngIf="showWarningMessage" (click)="openWarningMessage()" src="/assets/icons/warning-icon.svg" alt="warning-message">
<img class="message-icon" *ngIf="showInfoMessage" (click)="openInfoMessage()" src="/assets/icons/info-icon.svg" alt="info-message">

